<div class="modal-header">
  <h3>Update Subscription</h3>
  <button type="button" class="close-btn" (click)="onCancel()">
    <i class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <!-- Subscription Info Display -->
  <div class="subscription-info">
    <div class="info-grid">
      <div class="info-item">
        <label>Agent ID:</label>
        <span>{{ subscription.agentId }}</span>
      </div>
      <div class="info-item">
        <label>Zone:</label>
        <span>{{ subscription.zoneName }}</span>
      </div>
      <div class="info-item">
        <label>Subscription ID:</label>
        <span>{{ subscription.subscriptionId }}</span>
      </div>
      <div class="info-item">
        <label>Current Type:</label>
        <span>{{ getTypeText(subscription.type) }}</span>
      </div>
      <div class="info-item">
        <label>Current Cadence:</label>
        <span>{{ getCadenceText(subscription.cadence) }}</span>
      </div>
      <div class="info-item">
        <label>Payment Method:</label>
        <span>{{ getCurrentPaymentMethod() }}</span>
      </div>
      <div class="info-item">
        <label>Payment Status:</label>
        <span>{{ getCurrentPaymentStatus() }}</span>
      </div>
      <div class="info-item">
        <label>Amount:</label>
        <span>{{ formatCurrency(subscription.amount, subscription.currency) }}</span>
      </div>
    </div>
  </div>

  <hr class="divider">

  <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-group">
        <label for="type">Plan Type *</label>
        <select 
          id="type" 
          formControlName="type" 
          class="form-control"
          [class.is-invalid]="isFieldInvalid('type')">
          <option value="">Select Plan Type</option>
          <option *ngFor="let plan of planTypes" [value]="plan.value">
            {{ plan.label }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('type')">
          {{ getFieldError('type') }}
        </div>
      </div>

      <div class="form-group">
        <label for="cadence">Cadence *</label>
        <select 
          id="cadence" 
          formControlName="cadence" 
          class="form-control"
          [class.is-invalid]="isFieldInvalid('cadence')">
          <option value="">Select Cadence</option>
          <option *ngFor="let cadence of cadenceOptions" [value]="cadence.value">
            {{ cadence.label }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('cadence')">
          {{ getFieldError('cadence') }}
        </div>
      </div>

      <div class="form-group">
        <label for="status">Status *</label>
        <select 
          id="status" 
          formControlName="status" 
          class="form-control"
          [class.is-invalid]="isFieldInvalid('status')">
          <option value="">Select Status</option>
          <option *ngFor="let status of statusOptions" [value]="status.value">
            {{ status.label }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('status')">
          {{ getFieldError('status') }}
        </div>
      </div>
    </div>





    <!-- Error Message -->
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button 
        type="button" 
        class="btn btn-secondary" 
        (click)="onCancel()"
        [disabled]="isLoading">
        Cancel
      </button>
      <button 
        type="submit" 
        class="btn btn-primary" 
        [disabled]="isLoading || subscriptionForm.invalid">
        <app-loading 
          *ngIf="isLoading" 
          [isLoading]="true"
          size="small"
          color="white"
          [message]="''">
        </app-loading>
        <span *ngIf="!isLoading">Update Subscription</span>
        <span *ngIf="isLoading" class="ms-2">Updating...</span>
      </button>
    </div>
  </form>
</div>
